import {
  ArrowLeft,
  ArrowRight,
  BookOpen,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  CalendarX,
  Clock,
  Coffee,
  Home,
  Info,
  Leaf,
  Mail,
  MapPin,
  MessageCircle,
  Music2,
  Palette,
  Phone,
  Plus,
  Search,
  Settings2,
  ShieldCheck,
  Sparkles,
  Trash2,
  UserPlus,
  Users,
  createIcons,
} from "lucide";
import { Facebook, Instagram } from "./brand-icons";

/** Iconos usados en la app (auto-hospeados, sin CDN). Clave = nombre en PascalCase. */
const ICONS = {
  ArrowLeft,
  ArrowRight,
  BookOpen,
  CalendarCheck,
  CalendarClock,
  CalendarPlus,
  CalendarX,
  Clock,
  Coffee,
  Facebook,
  Home,
  Info,
  Instagram,
  Leaf,
  Mail,
  MapPin,
  MessageCircle,
  Music2,
  Palette,
  Phone,
  Plus,
  Search,
  Settings2,
  ShieldCheck,
  Sparkles,
  Trash2,
  UserPlus,
  Users,
};

/** Convierte `[data-lucide="trash-2"]` en iconos SVG. Idempotente: los SVG ya renderizados no se tocan. */
export function renderIcons(): void {
  createIcons({ icons: ICONS });
}
